export const DesiredPlans = [
  { value: "RE", text: 'Course Material' },
  { value: "IE", text: 'IELTS' },
  { value: "TO", text: 'TOFEL' },




]

const DesiredPlanSetter = (val) => {

  let value = null
  DesiredPlans.forEach((el) => {
    if (el.value === val) {
      value = el.text;
    }
  })
  return value;
}
export default DesiredPlanSetter;
